import {xor} from 'lodash';
import EnvironmentKey from './EnvironmentKey';

export function getEnvConfiguration(isProduction = false) {
    const configuration = isProduction ? EnvironmentKey.production : EnvironmentKey.development;

    return configuration;
}

const isProdEnv = process.env.REACT_APP_ENV === 'prod';

const solrSearch = {
    enable: false
};

const envKey = getEnvConfiguration(isProdEnv) || {};
const googleAutoCompleteModeOptions = {
    NORMAL: 'normal',
    DEBOUNCE: 'debounce'
    // REQUEST: 'request' // reserve mode
};

const sliceKey = {
    authentication: 'authentication',
    screenName: 'screenName',
    deviceDetails: 'DEVICE_DETAILS',
    offlineInventory: 'OFFLINE_INVENTORY',
    cart: 'CART',
    customer: 'CUSTOMER',
    order: 'ORDER',
    messages: 'MESSAGES',
    headerfooter: 'HEADER_FOOTER',
    userInfo: 'userInfo',
    preDidUrl: 'preDidUrl',
    legalDocument: 'LEGAL_DOCUMENT',
    applicationConfig: 'applicationConfig',
    searchInfo: 'searchInfo',
    searchResults: 'searchResults',
    planList: 'planList',
    genericConfig: 'genericConfig',
    tng: 'tng',
    CIInfo: 'ciInfo',
    deviceListFilter: 'deviceListFilter',
    so1OfferDetails: 'so1OfferDetails',
    bookingRef: 'BOOKING_REF',
    applicationWebViewConfig: 'applicationWebViewConfig',
    developerMode: 'developerMode'
};

const keyObjectPair = {
    isProdEnv,
    apiConfig: {
        key: 'API_KEY',
        ...envKey,
        channel: 'ssp',
        maxisWhatsAppLiveChat: {
            sendRequestUrl: 'https://api.whatsapp.com/send',
            phoneNumber: '60127781188'
        },
        maxisSupportEndPoint: 'https://www.maxis.com.my/support',
        mbhLoginRedirectPath: '/auth/welcome',
        mbhAuthEndpoint: '/mdi/oauth2/realms/root/realms/MBH/authorize'
    },
    sessionStorageKeys: {
        accessToken: 'accessToken',
        codeVerifier: 'codeVerifier'
    },
    sliceKey,
    countryCode: 60,
    maxisCookiesName: 'maxisBizStoreCookies',
    fibreCookieName: 'maxisBizStoreFibreCookies',
    cartIdCookiesName: 'cartId',
    maxisCookiesOptions: {
        path: '/',
        maxAgeInSecond: 900
    },
    maxisCartIdCookies: {
        domain: '.maxis.com.my'
    },
    maxisEncodedCookiesOptions: {
        useCookieEncoding: true
    },
    apiStatus: {
        fail: 'fail',
        success: 'success'
    },
    errorCodeKeyList: {
        hardStopUpgradeToMaxisCode: 'hardStopUpgradeToMaxis',
        errorCode119: 119,
        outstandingBillError: 113,
        maxedOutTotalContractCount: 114,
        zerolutionContractNotAvailable: [103, 104, 106, 107, 110],
        maxedOutTotalLineCount: [111, 117, 118],
        notAbleToRecontract: [103, 104, 106, 107, 110, 111, 114, 117, 118],
        tacValidationMaxTry: 'TAC0003',
        requestNotSupportError: 'requestNotSupportError',
        missingCustomerEmailOrder: 'missingCustomerEmailOrder',
        existingFibreError: 'existingFibreError',
        alreadySubmittedFibreRoiError: 105,
        errorCodeDAP: 'ERROR',
        defaultCodeForUndefinedError: 999,
        CAN_NOT_RECONTRACT_OR_UPGRADE: 'CAN_NOT_RECONTRACT_OR_UPGRADE',
        CAN_NOT_ADD_NEW_LINE: 'CAN_NOT_ADD_NEW_LINE',
        incorrectOrderDetails: 'incorrectOrderDetails',
        tokenInvalid: 'tokenInvalid'
    },

    localeLanguageKey: 'localeLanguage',

    maxisConsumerSiteUrl: 'https://www.maxis.com.my/',
    faqUrlEndPoint: 'https://www.maxis.com.my/support/device/buy-online/',
    planFAQUrlEndPoint: 'https://www.maxis.com.my/en/faq/products-services/mobile/postpaid/',
    maxisNeedAssistanceContactUs: 'https://www.maxis.com.my/en/contact-us/',
    maxisBusinessFibrePlansUrl: 'https://www.business.maxis.com.my/en/data-internet/fibre/#form',
    maxisBusines4gWifiPlansUrl: 'https://www.business.maxis.com.my/en/plans/4g-wifi/',
    maxisBusinesAirFibreUrl: 'https://www.business.maxis.com.my/en/data-internet/air-fibre/',
    maxisGroupPrivacyUrl: 'https://www.maxis.com.my/en/privacy-notice/',
    maxisTncUrl: 'https://www.business.maxis.com.my/en/terms-conditions/general/tnc/',
    maxisTermUse: 'https://www.maxis.com.my/en/terms-of-use/',
    maxisBusinessTnc: 'https://www.business.maxis.com.my/en/terms-conditions/',
    maxisSummaryTnc: 'https://www.business.maxis.com.my/en/terms-conditions/general/summary/',
    maxisBusinessFairUsagePolicy: 'https://www.business.maxis.com.my/en/terms-conditions/general/fair-usage-policy/',
    maxisBusinessSMELink: 'https://www.business.maxis.com.my/en/SME/',
    maxisBusinessSupportLink: 'https://www.business.maxis.com.my/en/support',
    onlineExclusiveOfferTncLink:
        'https://www.business.maxis.com.my/en/terms-conditions/data-internet/fibre-online-exclusive/',
    _30thAnniversaryOfferTncLink:
        'https://www.business.maxis.com.my/en/terms-conditions/data-internet/30th-anniversary-offer/',
    maxisBusinessFAQLink: 'https://www.business.maxis.com.my/en/faq/business-online-store/general/',
    fibreFaqUrl: 'https://www.business.maxis.com.my/en/faq/data-internet/fibre-online-exclusive/',
    fibreContactUs:
        'https://api.whatsapp.com/send?phone=60127781188&text=%5BMaxisBizStore%5D%3A%20Hi.%20I%20am%20interested%20to%20know%20more%20about%20Maxis%20Business%20Fibre.',
    solrSearch,
    googleAutoComplete: {
        mode:
            googleAutoCompleteModeOptions[process.env.REACT_APP_GOOGLE_AUTO_COMPLETE_MODE || ''] ||
            googleAutoCompleteModeOptions.DEBOUNCE,
        debouncePeriod: Number(process.env.REACT_APP_GOOGLE_AUTO_COMPLETE_DEBOUNCE_TIME) || 1000,
        minPlaceSearchChar: Number(process.env.REACT_APP_GOOGLE_AUTO_COMPLETE_MIN_SEARCH_CHAR_COUNT) || 4,
        modeOptions: googleAutoCompleteModeOptions,
        requestProperties: {
            componentRestrictions: {country: ['my']},
            types: ['geocode', 'establishment'],
            fields: ['place_id', 'address_components', 'formatted_address', 'geometry', 'name', 'types']
        }
    },
    fibreCoverageAutoComplete: {
        debouncePeriod: Number(process.env.REACT_APP_FIBRE_COVER_AUTO_COMPLETE_DEBOUNCE_TIME) || 1000,
        minSearchChar: Number(process.env.REACT_APP_IBRE_COVER_COMPLETE_MIN_SEARCH_CHAR_COUNT) || 4
    },
    fibreType: {
        fibreToTheHome: 'FTTH',
        fibreToTheOffice: 'FTTO',
        veryHighSpeedDigitalSubscriberLine: 'VDSL'
    },
    fibreDefaultPromoCode: 'FIBRE2MTHSOFF',
    pageName: {
        plp: 'productListing',
        solrSR: 'solrSearchResult',
        coverageCheck: 'Coverage Check Page'
    },
    seoAltTextPrefixes: {
        maxis: 'Maxis'
    },
    bannerTypes: {
        static: 'static',
        animated: 'animated',
        video: 'video'
    },
    productTypes: {
        devices: 'devices',
        mobilePlans: 'mobilePlans',
        fibreInternet: 'fibreInternet',
        wifiInternet: 'wifiInternet'
    },
    ipType: {
        dynamicIP: 'dynamicIP',
        fixedIP: 'fixedIP'
    },
    familyType: {
        fibre: 'fibre'
    },
    orderType: {
        ENTERPRISE_FIBRE_ORDER: 'ENTERPRISE-FIBRE-ORDER',
        NORMAL_ORDER: 'NORMAL-ORDER'
    },
    roiOrderType: {
        ENTERPRISE_FIBRE_ROI: 'ENTERPRISE-FIBRE-ROI'
    },
    roiNote: {
        faceIdFail: 'FR Fail - ID validation fail',
        currentBroadbandProvider: 'Current broadband provider - {providerName}',
        outOfCoverage: 'Out of Coverage'
    },
    cachedFormSessionKeys: {
        FORM_COVERAGE_CHECK: 'FORM_COVERAGE_CHECK'
    },
    maxisBrand: 'maxis',
    deliveryCountries: {
        malaysia: 'Malaysia'
    },
    maxisFibreCookieKeys: {
        ADDRESS1: 'ADDRESS1',
        ADDRESS2: 'ADDRESS2',
        ADDRESS3: 'ADDRESS3',
        BLOCKNAME: 'BLOCKNAME',
        BUILDINGNAME: 'BUILDINGNAME',
        CITY: 'CITY',
        AREA: 'AREA',
        FLOOR: 'FLOOR',
        FLOORNO: 'FLOORNO',
        POSTCODE: 'POSTCODE',
        SECTION: 'SECTION',
        STATE: 'STATE',
        STREETNAME: 'STREETNAME',
        STREETTYPE: 'STREETTYPE',
        TAG: 'TAG',
        TYPE: 'TYPE',
        UNIT: 'UNIT',
        UPCOMING: 'UPCOMING',
        GPS: 'GPS',
        PROJECTTYPE: 'PROJECTTYPE',
        FULLADDRESS: 'FULLADDRESS'
    },
    infraType: {
        fibre: 'Fibre'
    },
    flowType: {
        addNewLine: 'addNewLine'
    },
    channelCode: {
        BAU_CHANNEL: 'SS'
    },
    segment: {
        SME: 'SME'
    },
    idType: {
        foreignIdCardType: 'PASSPORT',
        malaysianIdCardType: 'NEWIC',
        BRN: 'BRN'
    },
    bccCompanyType: {
        sdnBhd: 'SBC',
        soleProprietorship: 'SP',
        association: 'ASS',
        berhadCompany: 'BC',
        embassy: 'EMB',
        foreignCompany: 'FC',
        foreignRepOffice: 'FRO',
        government: 'GOV',
        professionalFirm: 'PF'
    },
    companyType: {
        sdnBhd: 'Sdn Bhd Company',
        soleProprietorship: 'Sole Proprietor',
        partnership: 'Partnership',
        association: 'Association',
        berhadCompany: 'Berhad Company',
        embassy: 'Embassy',
        foreignCompany: 'Foreign Company',
        foreignRepOffice: 'Foreign Rep Office',
        government: 'Government',
        professionalFirm: 'Professional'
    },
    buildingType: {
        Commercial: 'Commercial',
        Industrial: 'Industrial',
        ShoppingMall: 'Shopping Mall',
        Shoplot: 'Shoplot',
        Residential: 'Residential'
    },
    validIDs: {
        malaysianIdCard: {
            value: 'NEWIC',
            text: 'NRIC',
            maxLen: 12,
            default: true
        },
        foreignIdCard: {
            value: 'PASSPORT',
            text: 'Passport',
            maxLen: 25,
            default: false
        }
    },
    faceIdQueryStrings: {
        idtype: {
            PASSPORT: 'Passport',
            NEWIC: 'MyKad'
        },
        language: 'English',
        retryno: 5,
        channelid: 'MBS'
    },
    frStatusList: {
        success: 'pass',
        fail: 'fail'
    },
    whatsAppMessageTemplate: {
        roiKnowMoreOffer: '[MaxisWeb_ROI]: Hi. I would like to know more about the offer. Please WhatsApp or call me.',
        mosDevicePurchaseInterest:
            "[MaxisOnlineStore] Hi. I'm interested in Maxis device purchase. Please call or WhatsApp me.",
        fibreFibreServiceAreaCheck:
            '[MaxisWeb_Fibre]: Hi. I would like to know more about Maxis Fibre in my area. Please WhatsApp or call me. Hi. Saya berminat untuk mengetahui lebih lanjut mengenai Maxis Fibre di kawasan saya. Sila WhatsApp atau telefon saya.',
        iphoneRoi: `[iPhone12] [BRE]: Hi. I'm interested to register for iPhone 12 pre order. Please call or WhatsApp me.`,
        cantFindInStorePickup:
            '[MaxisWeb_MaxisOnlineStore]: Hi. I would like to know more about the offer. Please WhatsApp me.',
        crpLookingForMoreOptions:
            '[MaxisWeb_MaxisPostpaid_SwitchtoMaxis]: Hi. I would like to know more about the offer. Please WhatsApp me.',
        tacInvalidGenericInput: '[MaxisWeb_TAC]: Live Agent',
        crpDowngradePlan:
            '[MaxisWeb_MaxisPostpaid]: Hi. I would like to know more about the offer. Please WhatsApp me.',
        fibreFreeSpeedUpgrade: '[Maxis_HomeFibre_CRP_CheckStatus]: Hi',
        bizStoreFibreInterest: '[MaxisBizStore]: Hi. I am interested to know more about Maxis Business Fibre.',
        infoCapture: '[MaxisBizStore]: Hi. I am interested to know more about Maxis Business Fibre.',
        floatyWhatsApp: '[MaxisBizStore]: Hi. I am interested to know more about Maxis Business Fibre.'
    },
    deliveryType: {
        SHIPPING: 'R',
        STORE_PICK_UP: 'MS'
    },
    deliveryCompany: {
        maxisCenterInventoryStoreCode: 'MC*'
    },
    contractTerm: {
        Contract_24: '24'
    },
    tncDocCategory: {
        ecom: 'ECOM',
        ecomMaxisGeneral: 'EcomMaxisGeneral',
        ecomPrivacy: 'ECOMPRIVACY',
        ecomZerolution: 'ECOMZerolution',
        ecomGoWiFi: 'ECOMGOWIFI',
        ecomInfoAck: 'ECOMCORRECTINFO',
        ecomZerolutionAudio: 'ECOMZEROLUTIONAUDIO',
        ecomMaxisPostpaidSSTC: 'EcomMaxisPostpaidSSTC',
        ecomMaxisFibre: 'EcomMaxisFibre',
        ecomMaxisFibreMop: 'EcomMaxisFibreMop',
        ecomMaxisFWBBOnly: 'EcomMaxisFWBBOnly',
        ecomMaxisFWBBMOPWIFIRouter: 'EcomMaxisFWBBMOPWIFIRouter',
        ecomMaxisFWBBWIFIRouter: 'EcomMaxisFWBBWIFIRouter',
        busGTC: 'BusGTC',
        busIndSTCA: 'BusIndSTCA',
        busIndSTCB: 'BusIndSTCB',
        ecomBooking: 'EcomBooking'
    },
    enableBccCheck: process.env.REACT_APP_ENABLE_BCC_CHECK !== 'false',
    realTime: {
        true: 'true',
        false: 'false'
    },
    analyticsConfig: {
        eventNames: {
            eventClicks: 'eventClicks',
            eventLoads: 'eventLoads',
            viewItem: 'view_item',
            addToCart: 'add_to_cart',
            beginCheckout: 'begin_checkout',
            purchase: 'purchase',
            coverageCheckStatus: 'coverageCheckStatus',
            facial_recognition_fail: 'facial_recognition_fail',
            facial_recognition_success: 'facial_recognition_success',
            order_details: 'order_details',
            order_tracking: 'order_tracking',
            login_success: 'login_success',
            headerNavig: 'Header Navig'
        },
        gaCategories: {
            ctaButton: 'CTA Button',
            coverageCheckResult: 'Coverage Check Result',
            loginButton: 'Login Button',
            login: 'Login',
            companyRegistration: 'Company Registration',
            emailVerification: 'Email Verification',
            phoneVerification: 'Phone Verification',
            faceRecognition: 'Facial Recognition',
            setAppointmentDate: 'Set Appointment Date',
            addShippingInfo: 'Add Shipping Info',
            orderDetails: 'Order Details',
            orderTracking: 'Order Tracking',
            headerNavigationMenu: 'Header Navigation Menu'
        },
        gaActions: {
            clickEvent: 'Click Event',
            onLoad: 'On Load',
            onlineExclusive: 'Online Exclusive',
            orderNow: 'Order Now',
            checkAvailability: 'Check Availability',
            registerYourInterest: 'Register Your Interest',
            addThis: 'Add This',
            login: 'Login',
            pageLoad: 'Page Load',
            continueButtonClick: 'Continue Button Click',
            continueButton: 'Continue Button',
            tryAgainButton: 'Try Again Button',
            nextButton: 'Next Button',
            statusCheck: 'Status Check',
            success: 'Success',
            fail: 'Fail',
            continueLabel: 'Continue'
        },
        gaLabels: {
            storeVisit: 'Store Visit',
            orderTracker: 'Order Tracker',
            checkCoverage: 'Check Coverage',
            coverageFailed: 'Coverage Failed',
            addThis: 'ADD THIS:{productName}',
            login: 'Login',
            success: 'Success',
            fail: 'Fail',
            registrationStart: 'Registration Start',
            verificationSuccess: 'Verification Success',
            verificationFailed: 'Verification Failed',
            registrationSuccess: 'Registration Success',
            appointmentSuccess: 'Appointment Success',
            deliveryDetails: 'Delivery Details',
            orderConfirmation: 'Order Confirmation',
            existingBroadband: 'Existing Broadband:{providerName}',
            viewOrderInfo: 'View Order Info'
        },
        gaPage: {},
        gaCurrency: {
            myr: 'MYR'
        },
        maxisBrand: 'Maxis',
        itemCategory: {
            plan: 'Plan',
            addOn: 'Add-On',
            device: 'Device',
            broadband: 'Broadband',
            maxisBusinessFibre: 'Maxis Business Fibre'
        }
    },
    contactRole: {
        authorisedSignatory: 'Authorised Signatory',
        authorisedPIC: 'Authorised PIC'
    }
};

export default keyObjectPair;
